module.exports = __webpack_public_path__ + "static/media/queues.52e70516.svg";